module.exports = __webpack_public_path__ + "static/media/diaryImg.6afa38f8.png";